import { TrackingStatus, MothershipStatus, EchoStatus, StandardStatus  } from './types';

function statusMapper(carrier, trackingInfo) {
    switch (carrier) {
        case "echo":
            return echoStatusMapper(trackingInfo.status)
        case "mothership":
            return mothershipStatusMapper(trackingInfo.status)
        case "fedex":
            return standardStatusMapper(trackingInfo)
        default:
            return defaultStatusMapper(trackingInfo)
    }
}

// Status mapping function that is specific to mothership 
// The mothership API doesn't return any departure or arrival
// dates for shipments, so the status is used instead
function mothershipStatusMapper(status) {

    switch(status) {
        case MothershipStatus.Unallocated:
        case MothershipStatus.FindingDriver:
        case MothershipStatus.DriverAllocated:
        case MothershipStatus.EnrouteToPickup:
        case MothershipStatus.ArrivedAtPickup:
          return TrackingStatus.Preparing
        case MothershipStatus.EnrouteToDelivery:
        case MothershipStatus.ArrivedAtDelivery:
          return TrackingStatus.InTransit
        case MothershipStatus.Completed:
        case MothershipStatus.DeliveryConfirmation:
          return TrackingStatus.Delivered
        case MothershipStatus.Cancelled:
          return TrackingStatus.Cancelled
        default:
          return TrackingStatus.Exception
      }
}

// Status mapping function that is specific to echo
// The echo API doesn't return any departure or arrival
// dates for shipments, so the status is used instead
function echoStatusMapper(status) {

    switch(status) {
        case EchoStatus.Ordered:
        case EchoStatus.Booked:
        case EchoStatus.CheckedIn:
        case EchoStatus.Loading:
            return TrackingStatus.Preparing
        case EchoStatus.PickedUp:
        case EchoStatus.Unloading:
            return TrackingStatus.InTransit
        case EchoStatus.Delivered:
            return TrackingStatus.Delivered
        case EchoStatus.Cancelled:
            return TrackingStatus.Cancelled
        default:
            return TrackingStatus.Exception
    }
}

function standardStatusMapper(trackingInfo) {
    switch(trackingInfo.status) {
        case StandardStatus.Created:
            return TrackingStatus.Preparing

        case StandardStatus.Departed:
        case StandardStatus.OutForDelivery:
        case StandardStatus.InTransit:
            if (trackingInfo.estimated_arrival) {
                return TrackingStatus.InTransit
            } else {
                return TrackingStatus.InTransitNoEstimation
            }

        case StandardStatus.Delivered:
            return TrackingStatus.Delivered

        case StandardStatus.MissedDelivery:
        case StandardStatus.Delayed:
        case StandardStatus.Exception:
            return TrackingStatus.Exception

        case StandardStatus.Cancelled:
            return TrackingStatus.Cancelled
        }

    return TrackingStatus.Unknown
}

// The shipping service doesn't correctly set statuses, it only sets exceptions
// to determine status, if it isn't exception, use the presence of arrival/departure
// info to dictate the status  we will show
function defaultStatusMapper(trackingInfo) {

  if (!trackingInfo) {
    return TrackingStatus.Unknown
  }
  if (trackingInfo.status === "exception") {
    return TrackingStatus.Exception
  }
  // if it has arrived, well then certainly it's delivered
  if (trackingInfo.arrival) {
    return TrackingStatus.Delivered
  }
  // ...if we have an estimated arrival, show it's in transit...
  if (trackingInfo.estimated_arrival) {
    return TrackingStatus.InTransit
  }
  // ...if we have only a departure date, show it's in transit but with no estimated arrival...
  if (trackingInfo.departure) {
    return TrackingStatus.InTransitNoEstimation
  }    
  // ...otherwise, default to the "preparing" screen
  return TrackingStatus.Preparing
}

export default statusMapper;
